import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from 'antd';

// 관리자 Route
import AdminRoutes from 'routes/admin.routes';
// 매장 관리자 Route
import StoreRoutes from './store.routes';
// 쇼핑몰 Route
import MainRoutes from './main.routes';
import { DEPLOY_TYPE, DOMAIN_URL } from 'utils';
import ShopRoutes from './shop.routes';
import { AuthFail, AuthSuccess, Auth } from 'components';

const Routemap = () => {
  /* ===== ROUTE ===== */
  const location = useLocation();

  /* ===== STATE ===== */

  /* ===== VARIABLES ===== */
  const hostname = window.location.hostname;

  /* ===== FUNCTION ===== */
  /**
   * 도메인에 따른 Route 렌더링
   * --
   */
  const renderRoutes = () => {
    const split = DEPLOY_TYPE === 'development' ? '-jm-coffee.' : '.';

    switch (hostname) {
      case `admin${split}${DOMAIN_URL}`:
        return <Route index path="/*" element={<AdminRoutes />} />;
      case `shop${split}${DOMAIN_URL}`:
        return <Route index path="/*" element={<ShopRoutes />} />;
      case `store${split}${DOMAIN_URL}`:
        return <Route index path="/*" element={<StoreRoutes />} />;
      case `mall${split}${DOMAIN_URL}`:
        return <Route index path="/*" element={<MainRoutes />} />;
      default:
        return <Route index path="/*" element={<MainRoutes />} />;
    }
  };

  /* ===== HOOKS ===== */
  /**
   * 메인 라우트 처리 + 라우트 이동 시 최상단으로 스크롤
   * --
   */
  useEffect(() => {
    const {
      origin,
      hash,
      pathname: path,
      search: params,
      hostname,
      protocol,
      host,
    } = window.location;
    const { pathname } = location;

    if (!hash) {
      window.location.href = `${origin}/#${
        path === '/' ? '/main' : path
      }${params}`;
      return;
    }

    if (pathname === '/') {
      window.location.href = `${origin}/#/main`;
    }
    // if(pathname === '/index.html'){
    //   window.location.href = `${origin}/#/main`;
    // }

    const split = hostname.split('.');

    // console.log('split ===>', split);

    const sub = [
      'mall',
      'shop',
      'admin',
      'store',
      'www',
      'jm-coffee',
      'mall-jm-coffee',
      'admin-jm-coffee',
      'shop-jm-coffee',
      'store-jm-coffee',
    ];

    if (!sub.includes(split[0]) && DEPLOY_TYPE !== 'local') {
      const sub = DEPLOY_TYPE === 'development' ? 'mall-jm-coffee' : 'mall';
      window.location.href = `${protocol}//${sub}.${host}/${hash}`;
    }

    if (split[0] === 'www') {
      window.location.href = `${protocol}//mall.${DOMAIN_URL}`;
    }

    // 특정 화면에서 전달한 Y 좌표가 있으면 쿼리 변경 후 해당 위치로 부드럽게 이동합니다.
    const scrollTargetY = Number(location.state?.scrollTargetY);

    if (Number.isFinite(scrollTargetY)) {
      window.scrollTo({ top: scrollTargetY, behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  /* ===== RENDER ===== */
  return (
    <>
      <Layout>
        {/* 라우터 */}
        <Routes>
          {renderRoutes()}
          <Route path="auth/*">
            <Route index element={<Auth />} />
            <Route path="success" element={<AuthSuccess />} />
            <Route path="fail" element={<AuthFail />} />
          </Route>
        </Routes>
      </Layout>
    </>
  );
};

export default Routemap;
